import React from 'react'
import { IconContext } from 'react-icons'
import { FaSpinner } from 'react-icons/fa'

const Spinner = () => (
    <div className="spinnerWrapper">
        <div className="spinner">
            <IconContext.Provider value={{ className: 'fa-pulse', size: '4em' }}>
                <FaSpinner />
            </IconContext.Provider>
        <span className="spinnerText"> Loading ...</span> 
        </div>
    </div>
)

export default Spinner